module.exports = __webpack_public_path__ + "sgby/img/sunshangxiang-pic.b36aa4f.png";